
const lookupDay = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const lookupMonth = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function eventDateString(event) {
    const start = new Date(event.start);
    const hours = start.getHours();
    const meridan = hours > 12 ? "PM" : "AM";
    const hourStr = hours > 12 ? hours - 12 : hours;
    const date = start.getDate() % 31;
    const st = date === 1 ? "st" : date === 2 ? "nd" : date === 3 ? "rd" : "th";
    const dateStr = `${lookupDay[start.getDay()]} ${lookupMonth[start.getMonth()]} ${start.getDate()}${st} @ ${hourStr}:${String(start.getMinutes()).padStart(2, "0")} ${meridan}`
    return(dateStr);
}


export function eventMarkup(event) {
    if (!event.description) {
        return("")
    }
    
    const markup = event.description.replace(/(\n|\\n)+/g, '<br />');
    return(markup);
}

